const text = value => String(value ?? '').trim().replace(/\s+/g, ' ').toUpperCase()
const email = value => String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase()
const phone = value => String(value ?? '').replace(/[_\s-]/g, '')

const hasPecBypass = contact => {
  const bypass = contact.bypass_pec
  return bypass && typeof bypass === 'object'
    ? bypass.value === true || Number(bypass.value) === 1
    : Number(bypass) === 1
}

const contactValues = (contact, isDomestic) => {
  return [
    text(contact.toponimo),
    text(contact.indirizzo),
    text(contact.civico),
    text(contact.cap),
    text(contact.cod_comune ?? contact.comune),
    phone(contact.cellulare || contact.cell),
    email(contact.email),
    // Domestic contacts are compared using the fields available in their form.
    ...(!isDomestic ? [phone(contact.telefono || contact.tel), Number(contact.cod_rapp ?? 0)] : [])
  ]
}

const hasSamePecOrBypass = (contact, proposed, isAdmin, isDomestic) => {
  if (isDomestic) return true

  const samePec = email(contact.pec) === email(proposed.pec)
  const sameActiveBypass = isAdmin && hasPecBypass(contact) && hasPecBypass(proposed)
  return samePec || sameActiveBypass
}

export const findDuplicateContact = (contact, proposedContacts, isAdmin = false, isDomestic = false) => {
  const values = contactValues(contact, isDomestic)
  return proposedContacts.find(proposed => {
    if (proposed.same_to_client) return false
    if (proposed.invalid_fields?.length > 0 || proposed.selectable === false) return false
    // Updating a contact must remain possible without matching it against itself.
    if (contact.updated && [contact.id, contact.prev_id].some(id => id != null && String(proposed.id) === String(id))) return false
    return contactValues(proposed, isDomestic).every((value, index) => value === values[index])
      && hasSamePecOrBypass(contact, proposed, isAdmin, isDomestic)
  })
}
